export const environment = {
  production: true,
  domain: 'dev-qpzcq-jp.us.auth0.com',
  clientId: 'poJWoUG3EHZBaPcWa2HAV1o89K87Px57',
  cognito: {
    userPoolId: 'eu-west-1_NkiBrWpxL',
    userPoolWebClientId: '16mr81n3icn2nu2tb6n7olp2r',
  },
  buildHash: '2026-07-05a', // bump on each deploy that changes i18n JSON
};

export const URLS = {
  API: 'https://productionapi.slickchain.com/',
  APIPDF: 'https://pdf.slickchain.com/'
};
